/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/LatLonResource'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./LatLonResource'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.PlaceResource = factory(root.GisServerApis.ApiClient, root.GisServerApis.LatLonResource);
  }
}(this, function(ApiClient, LatLonResource) {
  'use strict';




  /**
   * The PlaceResource model module.
   * @module model/PlaceResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>PlaceResource</code>.
   * A class that includes the information of a place.
   * @alias module:model/PlaceResource
   * @class
   */
  var exports = function() {
    var _this = this;


















  };

  /**
   * Constructs a <code>PlaceResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PlaceResource} obj Optional instance to populate.
   * @return {module:model/PlaceResource} The populated <code>PlaceResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number');
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('address')) {
        obj['address'] = ApiClient.convertToType(data['address'], 'String');
      }
      if (data.hasOwnProperty('addressComponent')) {
        obj['addressComponent'] = ApiClient.convertToType(data['addressComponent'], {'String': 'String'});
      }
      if (data.hasOwnProperty('optionalNames')) {
        obj['optionalNames'] = ApiClient.convertToType(data['optionalNames'], {'String': 'String'});
      }
      if (data.hasOwnProperty('administrativeLevel')) {
        obj['administrativeLevel'] = ApiClient.convertToType(data['administrativeLevel'], 'String');
      }
      if (data.hasOwnProperty('wellKnownText')) {
        obj['wellKnownText'] = ApiClient.convertToType(data['wellKnownText'], 'String');
      }
      if (data.hasOwnProperty('houseNumber')) {
        obj['houseNumber'] = ApiClient.convertToType(data['houseNumber'], 'String');
      }
      if (data.hasOwnProperty('postcode')) {
        obj['postcode'] = ApiClient.convertToType(data['postcode'], 'String');
      }
      if (data.hasOwnProperty('osmId')) {
        obj['osmId'] = ApiClient.convertToType(data['osmId'], 'Number');
      }
      if (data.hasOwnProperty('placeCategory')) {
        obj['placeCategory'] = ApiClient.convertToType(data['placeCategory'], 'String');
      }
      if (data.hasOwnProperty('placeType')) {
        obj['placeType'] = ApiClient.convertToType(data['placeType'], 'String');
      }
      if (data.hasOwnProperty('properties')) {
        obj['properties'] = ApiClient.convertToType(data['properties'], {'String': 'String'});
      }
      if (data.hasOwnProperty('locationType')) {
        obj['locationType'] = ApiClient.convertToType(data['locationType'], 'String');
      }
      if (data.hasOwnProperty('reverseGeocode')) {
        obj['reverseGeocode'] = ApiClient.convertToType(data['reverseGeocode'], 'String');
      }
      if (data.hasOwnProperty('reverseGeocodeTemplate')) {
        obj['reverseGeocodeTemplate'] = ApiClient.convertToType(data['reverseGeocodeTemplate'], 'String');
      }
      if (data.hasOwnProperty('centerPoint')) {
        obj['centerPoint'] = LatLonResource.constructFromObject(data['centerPoint']);
      }
    }
    return obj;
  }

  /**
   * The ID of the palce.
   * @member {Number} id
   */
  exports.prototype['id'] = undefined;
  /**
   * The place name.
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * The address of the place.
   * @member {String} address
   */
  exports.prototype['address'] = undefined;
  /**
   * The components of the address.
   * @member {Object.<String, String>} addressComponent
   */
  exports.prototype['addressComponent'] = undefined;
  /**
   * The optional names of the place.
   * @member {Object.<String, String>} optionalNames
   */
  exports.prototype['optionalNames'] = undefined;
  /**
   * The administrative level of the place
   * @member {String} administrativeLevel
   */
  exports.prototype['administrativeLevel'] = undefined;
  /**
   * The WKT of the place shape.
   * @member {String} wellKnownText
   */
  exports.prototype['wellKnownText'] = undefined;
  /**
   * The house number of the place.
   * @member {String} houseNumber
   */
  exports.prototype['houseNumber'] = undefined;
  /**
   * The postcode of the place.
   * @member {String} postcode
   */
  exports.prototype['postcode'] = undefined;
  /**
   * The OsmId of the place.
   * @member {Number} osmId
   */
  exports.prototype['osmId'] = undefined;
  /**
   * The category of the place.
   * @member {String} placeCategory
   */
  exports.prototype['placeCategory'] = undefined;
  /**
   * The type of the place.
   * @member {String} placeType
   */
  exports.prototype['placeType'] = undefined;
  /**
   * The properties of the location.
   * @member {Object.<String, String>} properties
   */
  exports.prototype['properties'] = undefined;
  /**
   * The place type, the valid values are \"Address\", \"Place\".
   * @member {String} locationType
   */
  exports.prototype['locationType'] = undefined;
  /**
   * The ReverseGeocode formatted based on the template.
   * @member {String} reverseGeocode
   */
  exports.prototype['reverseGeocode'] = undefined;
  /**
   * The result template of the ReverseGeocode.
   * @member {String} reverseGeocodeTemplate
   */
  exports.prototype['reverseGeocodeTemplate'] = undefined;
  /**
   * The center point of the place.
   * @member {module:model/LatLonResource} centerPoint
   */
  exports.prototype['centerPoint'] = undefined;



  return exports;
}));



